import React from "react";

const WarningModal = ({ visible, onAgree, onCancel }) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-5 w-11/12 max-w-md">
        <h2 className="text-xl font-bold text-black mb-3 text-center">
          Content Guidelines
        </h2>
        <p className="text-base text-gray-700 mb-3 text-center">
          Please ensure your post complies with our community guidelines. Do not
          upload:
        </p>
        <ul className="text-base text-gray-700 mb-3 text-left list-disc list-inside">
          <li>Offensive or harmful content</li>
          <li>Explicit or 18+ material</li>
          <li>Misinformation or false claims</li>
          <li>Content that violates our terms of service</li>
        </ul>
        <p className="text-base text-gray-700 mb-5 text-center">
          By proceeding, you confirm that your post adheres to these guidelines.
        </p>
        <div className="flex justify-between">
          <button
            className="flex-1 bg-gray-400 text-white text-sm py-2 rounded-md mx-1 font-semibold hover:bg-gray-500"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-red-700 text-white text-sm py-2 rounded-md mx-1 font-semibold hover:bg-red-800"
            onClick={onAgree}
          >
            Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
